export const ATTEVENT_LOADING = "ATTEVENT_LOADING";
export const ATTEVENT_RESET = "ATTEVENT_RESET";
export const GET_ATTEVENT = "GET_ATTEVENT";
export const GET_ATTEVENT_SUCCESS = "GET_ATTEVENT_SUCCESS";
export const GET_ATTEVENT_FAIL = "GET_ATTEVENT_FAIL";
export const DELETE_ATTEVENT = "DELETE_ATTEVENT"
export const DELETE_ATTEVENT_SUCCESS = "DELETE_ATTEVENT_SUCCESS"
export const DELETE_ATTEVENT_FAIL = "DELETE_ATTEVENT_FAIL"
export const UPDATE_ATTEVENT = "UPDATE_ATTEVENT"
export const UPDATE_ATTEVENT_SUCCESS = "UPDATE_ATTEVENT_SUCCESS"
export const UPDATE_ATTEVENT_FAIL = "UPDATE_ATTEVENT_FAIL"
export const ADD_NEW_ATTEVENT = "ADD_NEW_ATTEVENT"
export const ADD_ATTEVENT_SUCCESS = "ADD_ATTEVENT_SUCCESS"
export const ADD_ATTEVENT_FAIL = "ADD_ATTEVENT_FAIL"